
import RightSidebar from "../../MainContent/RightSidebar/RightSidebar";
import Marquee from "../../Marquee/Marquee";
import Minister from "./Minister";

const Vazorat = () => {
    return (
        <div class="container">
            <Minister />
            <Marquee />
        </div>
    )
}

export default Vazorat;